module.exports = __webpack_public_path__ + "img/flow_icon04.0a260a0b.png";